module.exports = __webpack_public_path__ + "static/media/startsAndLine.svg";